export default "__VITE_ASSET__BSBi94vz__"